import { useContext, useEffect, useRef, useState } from "react";
import { useWindowDimensions, View, Animated } from "react-native";
import { LanguageContext } from "../contexts/language";
import { UserContext } from "../contexts/user";
import ActionSheet from "./action_sheet";
import Button from "./button";
import TxtInput from "./txt_input";
import * as Colours from '../colours';
import Txt from "./txt";
//LANGUAGE

const num_re = /\d/;
const lower_case = /[a-z]/;
const upper_case = /[A-Z]/;

const OkBit = props => {
    const { label, ok } = props;
    const driver = useRef(new Animated.Value(0)).current;
    const color = driver.interpolate({inputRange: [0, 1], outputRange: [Colours.grey, 'green']})

    useEffect(() => {
        if (ok) {
            Animated.timing(driver, {toValue: 1, duration: 200, useNativeDriver: false }).start();
        } else {
            Animated.timing(driver, {toValue: 0, duration: 200, useNativeDriver: false }).start();
        }
    }, [ok])

    return (
        <Animated.View style={{borderRadius: 10, borderWidth: 1, borderColor: color, padding: 8, flexDirection: "row", justifyContent:"center", alignItems:'center', margin: 5, alignSelf:'stretch'}}>
            <Animated.View style={{borderRadius: 100, width: 8, height: 8, backgroundColor: color, marginRight: 10}}>

            </Animated.View>
            <Animated.Text style={{fontSize: 12, color: color, fontWeight:'bold'}}>{label}</Animated.Text>
        </Animated.View>
    )
}

const CreatePasswordAs = props => {
    const lang = useContext(LanguageContext);
    const { height, width } = useWindowDimensions();
    const { actions: { showForgotModal, createPassword, showCreatePassword }, create_password_showing: create_token, token } = useContext(UserContext);
    const [password, set_password] = useState('');
    const [confirm, set_confirm] = useState('');
    const [loading, set_loading] = useState(false);
    const [match, set_match] = useState(true);
    const [status, set_status] = useState({ok: false, errors: { lower: true, upper: true, num:true, length: true }})
    const visible = create_token !== null;
    const close = () => showCreatePassword(null);

    const validatePassword = () => {
        const errors = {
            lower: !lower_case.test(password),
            upper: !upper_case.test(password),
            num: !num_re.test(password),
            length: password.length < 8,
        }
        set_status({
            ok: !errors.lower && !errors.upper && !errors.num && !errors.length,
            errors
        })
    }

    useEffect(() => {
        validatePassword()
    }, [password])

    useEffect(() => {
        set_match(password === confirm);
    }, [password, confirm])


    const submit = async () => {
        set_loading(true);
        await createPassword(password);
        set_loading(false);
    }

    return (
        <ActionSheet
            height={height * 0.7}
            close={close}
            visible={visible}
            cred="CPASS"
            title={lang.create_password_as.create_a_password}
        >
            <View style={{flex: 1, alignSelf:'stretch', marginTop: 10, alignItems:'center'}}>
                <View style={{flex: 1, alignSelf:'stretch'}}>
                    <View style={{flex: 1, justifyContent:'flex-start', alignItems:'stretch', alignSelf:'stretch'}}>
                        <Txt style={{marginTop: 20, marginBottom: 20}}>{lang.create_password_as.please_use}</Txt>
                        <View style={{alignSelf:'stretch'}}>
                            <Txt style={{marginBottom: 2}}>{lang.create_password_as.password}</Txt>
                            <TxtInput 
                                value={password} 
                                onChange={set_password}
                                can_clear
                                onClear={() => set_password('')}
                                placeholder={lang.create_password_as.password}
                                style={{marginBottom: 10, borderWidth: 1, borderColor:Colours.light_grey, height: 40}}
                                inputStyle={{fontSize: 14}}
                                secureTextEntry
                                />
                            <Txt style={{marginBottom: 2}}>{lang.create_password_as.confirm_password}</Txt>
                            <TxtInput 
                                value={confirm} 
                                onChange={set_confirm}
                                can_clear
                                onClear={() => set_confirm('')}
                                placeholder={lang.create_password_as.confirm_password}
                                style={{marginBottom: 10, borderWidth: 1, borderColor:Colours.light_grey, height: 40}}
                                inputStyle={{fontSize: 14}}
                                secureTextEntry
                                />

                            <View style={{alignSelf:'stretch', alignItems:'center'}}>
                                <View style={{alignSelf:'stretch'}}>
                                    <View style={{alignSelf:'stretch', flexDirection:'row', justifyContent:'space-between', padding: 8}}>
                                        <OkBit label="A-Z" ok={status.errors.upper === false ? true : false} />
                                        <OkBit label="a-z" ok={status.errors.lower === false ? true : false} />
                                        <OkBit label="123" ok={status.errors.num === false ? true : false} />
                                        <OkBit label="8+" ok={status.errors.length === false ? true : false} />
                                    </View>
                                    <OkBit label="Password Match" ok={password === confirm} />
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={{alignSelf:'stretch', flexDirection:'column', marginBottom: 30}}>
                        <Button disabled={(status.ok === true && match) ? false : true} loading={loading} onPress={submit}>{lang.create_password_as.submit}</Button>
                    </View>
                </View>

            </View>
        </ActionSheet>
    )
}

export default CreatePasswordAs;